//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_sceneMode2D = 2.0;\n\
";
